import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {payoutsActions} from "_actions";
import styles from "./Styles.module.css";

class Payouts extends Component {
    componentDidMount() {
        const { dispatch } = this.props
        dispatch(payoutsActions.getAll())
    }

    render() {
        const { all_payouts } = this.props
        return (
            <div className="main-content-wrapper top-rel-100 margin-0-40">
                <div className={styles.rateContainer}>
                    <Link to="/create-payout-rate" className={`btn btn-success pull-right ${styles["mb15"]}`}>
                        Create Payout Rate
                    </Link>
                    <table className="table table-responsive clear-both">
                        <thead>
                        <tr>
                            <th>Currency</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>{''}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {all_payouts && all_payouts.length > 0 && all_payouts.map(payout =>
                            <tr key={payout.id}>
                                <td className={styles.alignMiddle}>
                                    {payout.currency &&
                                    `${payout.currency.label} (${payout.currency.code})`
                                    }
                                    {! payout.currency &&
                                    'Unavailable'
                                    }
                                </td>
                                <td className={styles.alignMiddle}>{payout.amount}</td>
                                <td className={styles.alignMiddle}>{payout.label}</td>
                                <td className={styles.alignMiddle}>
                                    <Link to={`/edit-payout-rate/${payout.id}`} className="btn btn-info btn-sm">
                                        Edit Pricing
                                    </Link>
                                </td>
                            </tr>
                        )}
                        {all_payouts && all_payouts.length === 0 &&
                            <tr>
                                <td className={styles.noRates} colSpan="3">
                                    No Payout Rates have been previously added
                                </td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { payout: { all_payouts }} = state
    return {
        all_payouts
    }
}

let payoutConnect = connect(mapStateToProps)(Payouts)

export { payoutConnect as Payouts }